import { render, staticRenderFns } from "./WidgetEditText.vue?vue&type=template&id=7b039b35&scoped=true&"
import script from "./WidgetEditText.vue?vue&type=script&lang=js&"
export * from "./WidgetEditText.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditText.vue?vue&type=style&index=0&id=7b039b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b039b35",
  null
  
)

export default component.exports